import { useChatSocket } from '@/entities/chat-v2';
import { useIntermediateSocket } from '@/entities/intermediate';
import { useBreakWatcher } from '@/features/tasks/model/modal/useBreakWatcher';
import { useBreakFinishedReminder } from '@/features/tasks/model/useBreakFinishedReminder';
import { useIntermediateTimeMonitor } from '@/features/tasks/model/views/useIntermediateTimeMonitor';
import { useTaskTimeMonitor } from '@/features/tasks/model/views/useTaskTimeMonitor';
import { useAutoCloseWorkday } from '@/hooks/timeman/useWorkDay';
import { usePresenceSocket } from '@/shared/lib/usePresenceSocket';
import { useIsNativeSession } from '@/store/auth';

import { BreakTimerBootstrap } from './BreakTimerBootstrap';

export function AppBootstraps() {
  const isNativeSession = useIsNativeSession();

  useAutoCloseWorkday();
  useTaskTimeMonitor();
  useBreakFinishedReminder();
  useBreakWatcher();
  useIntermediateTimeMonitor();

  return (
    <>
      {/* Сокеты — отдельным компонентом, чтобы их можно было не монтировать
          под нативной сессией, не делая условными сами хуки. */}
      {isNativeSession ? <NativeRealtime /> : <LegacyRealtime />}
      <BreakTimerBootstrap />
    </>
  );
}

/**
 * Живые каналы нового бэка. Единый сокет чатов `/v2/chats/ws` по инструкции
 * бэка открывается при входе в приложение, а не на каждый чат: в нём события
 * всех чатов пользователя, по ним обновляются и список, и открытая лента.
 */
function NativeRealtime() {
  useChatSocket();

  return null;
}

/**
 * Живые каналы старого бэка: присутствие и мониторинг промежуточных дел.
 *
 * Оба авторизуются куками `jwt_token` сессии Bitrix24 и под нативной учётной
 * записью работать не могут: `/ws` принимает только битриксовый токен, а
 * `/ws/intermediate` в новом бэке отсутствует вовсе. Пока нативная сессия
 * живёт без них — иначе оба висли бы в бесконечном реконнекте.
 */
function LegacyRealtime() {
  usePresenceSocket();
  useIntermediateSocket();

  return null;
}
